var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89995 1.28465C6.73703 0.717956 5.43062 0.399994 4.04995 0.399994C2.66928 0.399994 1.36287 0.717956 0.199951 1.28465V12.2847C1.36287 11.718 2.66928 11.4 4.04995 11.4C5.88542 11.4 7.58963 11.9619 8.99995 12.9231C10.4103 11.9619 12.1145 11.4 13.95 11.4C15.3306 11.4 16.637 11.718 17.7999 12.2847V1.28465C16.637 0.717956 15.3306 0.399994 13.95 0.399994C12.5693 0.399994 11.2629 0.717956 10.1 1.28465V9.19999C10.1 9.80751 9.60746 10.3 8.99995 10.3C8.39244 10.3 7.89995 9.80751 7.89995 9.19999V1.28465Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.5a9ec4de6333940e45feb8fb6c701ae3.svg";
export { ForwardRef as ReactComponent };